import { GroupSetting } from '@griply/types';
import { createContext, useContext } from 'react';
import { ID } from 'shared/types/id';
import { Task } from 'shared/types/task';

export type PriorityRenderData = {
  groupSettings: GroupSetting;
  tasksMap: Record<ID, Task>;
  tasks: Task[];
  today: Date;
  denseFormat?: boolean;
  defaultNewTaskDate?: Date;
};

export const PriorityRenderDataContext =
  createContext<PriorityRenderData | null>(null);

export const usePriorityRenderData = (): PriorityRenderData => {
  const data = useContext(PriorityRenderDataContext);
  if (!data) {
    throw new Error(
      'usePriorityRenderData must be used within a PriorityGroupingTasksList',
    );
  }
  return data;
};
